import React from 'react'
import './footer.css'

export const Footer = () => {
    return (
        <footer >
            <p >© 2024-2025 Desarrollado por DC Solutions | Reservados todos los derechos</p>
        </footer>
    )
}
